import { ModalMode } from '../interfaces';

export function* modalChangeModeWorker(modalMode: ModalMode) {
  // console.log('Modal mode changed: ', modalMode); // todo: move use effect callback from DutyTimeEntryModal to here
}
